var map = {
	"./Audio 1.pdf": 1440,
	"./Audio 2.pdf": 1441,
	"./Audio 3.pdf": 1442,
	"./Audio 4.pdf": 1443,
	"./Audio 5.pdf": 1444,
	"./Audio 6.pdf": 1445,
	"./Audio 7.pdf": 1446,
	"./Audio 8.pdf": 1447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1439;